module.exports = __webpack_public_path__ + "static/patagonia_395x285-b35ea35dce29cb7518203c15f886de44.png";